import { Confetti } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import AuthLayout from '../AuthLayout'
import DownloadApp from '../DownloadApp'

const SignupSuccess = () => {
  const { t } = useTranslation(['auth'])
  const navigate = useNavigate()

  return (
    <AuthLayout hideLogo>
      <div className="auth__success">
        <Confetti size={50} />
        <h2 className="auth__success__congrats">{t('auth:signupSuccess.congratulations')}</h2>
        <p>{t('auth:signupSuccess.description')}</p>
        <DownloadApp content={t('auth:signupSuccess.downloadAppContent')} />
        <button type="button" onClick={() => navigate('/login')} className="button button-primary">
          {t('auth:signupSuccess.backToLogin')}
        </button>
      </div>
    </AuthLayout>
  )
}

export default SignupSuccess
